export const runAsyncTasksInOrder = async (tasks: Array<() => Promise<void>>, continueOnError: boolean = true) => {
    for (const task of tasks) {
        try {
            await task()
        } catch (e) {
            if (!continueOnError) throw e
        }
    }
}
